<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="Lista de Productos" />
    <div class="px-3 px-xl-4 pt-3 flex-grow-1">
      <ProductsList />
    </div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MainHeader    from '../../components/Layouts/MainHeader.vue';
import MainSidebar   from '../../components/Layouts/MainSidebar.vue';
import BreadcrumbMenu from '../../components/Common/BreadcrumbMenu.vue';
import ProductsList  from '../../components/Products/ProductsList/ProductsList.vue';
import MainFooter    from '../../components/Layouts/MainFooter.vue';

export default defineComponent({
  name: 'ProductsListPage',
  components: { MainHeader, MainSidebar, BreadcrumbMenu, ProductsList, MainFooter },
});
</script>
